import AvailabilitiesCalendar from './AvailabilitiesCalendar';

export default AvailabilitiesCalendar;
